import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_6173_32130)">
        <path
          d="M0 19.4389C0 14.8518 0 12.5582 0.514154 10.6787C1.86743 5.73202 5.73202 1.86743 10.6787 0.514154C12.5582 0 14.8518 0 19.4389 0H44.5611C49.1482 0 51.4418 0 53.3213 0.514154C58.268 1.86743 62.1326 5.73202 63.4858 10.6787C64 12.5582 64 14.8518 64 19.4389V44.5611C64 49.1482 64 51.4418 63.4858 53.3213C62.1326 58.268 58.268 62.1326 53.3213 63.4858C51.4418 64 49.1482 64 44.5611 64H19.4389C14.8518 64 12.5582 64 10.6787 63.4858C5.73202 62.1326 1.86743 58.268 0.514154 53.3213C0 51.4418 0 49.1482 0 44.5611V19.4389Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.9997 56.3197C45.4313 56.3197 56.3197 45.4313 56.3197 31.9997C56.3197 18.5681 45.4313 7.67969 31.9997 7.67969C18.5681 7.67969 7.67969 18.5681 7.67969 31.9997C7.67969 45.4313 18.5681 56.3197 31.9997 56.3197ZM48.2129 19.7633C48.2129 19.7633 42.925 24.6579 42.925 31.9998C42.925 39.3416 48.2129 44.2362 48.2129 44.2362L44.236 48.2131C44.236 48.2131 39.254 42.9252 31.9995 42.9252C24.7451 42.9252 19.7631 48.2131 19.7631 48.2131L15.7862 44.2362C15.7862 44.2362 21.0741 39.3416 21.0741 31.9998C21.0741 24.6579 15.7862 19.7633 15.7862 19.7633L19.7631 15.7864C19.7631 15.7864 24.7888 21.0743 31.9995 21.0743C39.2103 21.0743 44.236 15.7864 44.236 15.7864L48.2129 19.7633Z"
          fill="#FFC806"
        />
      </g>
      <defs>
        <clipPath id="clip0_6173_32130">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
